import { IApplicationState } from '../../../../types/redux';

export function priceLteSelector(state: IApplicationState): number | undefined {
  return state.filters.jsonQuery.price?.value.lte;
}
